module.exports = __webpack_public_path__ + "img_pp@2x.jpg?a22237f4e53755de7f2b11dc5ed447e1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_pp@2x.jpg
// module id = 212
// module chunks = 0